var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoueAiDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M7.00149 5.79492C7.043 5.79492 7.08108 5.81824 7.10028 5.85542L9.10727 9.68191C9.11706 9.70204 9.13257 9.71876 9.15184 9.72992L12.9415 11.7587C12.9775 11.7784 13 11.8164 13 11.8577C13 11.8991 12.9775 11.9371 12.9415 11.9568L9.15332 13.9856C9.13351 13.9965 9.11745 14.0132 9.10727 14.0336L7.09879 17.8601C7.07959 17.8973 7.04152 17.9206 7 17.9206C6.95848 17.9206 6.92041 17.8973 6.90121 17.8601L4.89273 14.0336C4.88255 14.0132 4.86649 13.9965 4.84668 13.9856L1.0585 11.9568C1.02246 11.9371 1 11.8991 1 11.8577C1 11.8164 1.02246 11.7784 1.0585 11.7587L4.84668 9.72992C4.86594 9.71876 4.88146 9.70204 4.89125 9.68191L6.90121 5.85542C6.92189 5.81824 6.95997 5.79492 7.00149 5.79492Z",
    stroke: "#86898E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M18.9992 4.39286L16.3121 1L13.625 4.39286L16.3121 7.78571L18.9992 4.39286Z",
    stroke: "#86898E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M16.3121 14.5723V20.0008M13.625 17.2866H18.9992",
    stroke: "#86898E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoueAiDashboard);
export default __webpack_public_path__ + "static/media/youeAI-dashboard.96cdce1a69d0b7dd0c3c64d37eb06e0f.svg";
export { ForwardRef as ReactComponent };